import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import styled from "styled-components";

import { StickyCell } from "@/common/StyledComponents";

export const CustomRow = styled(TableRow)`
    &:last-child td, &:last-child th: {
        border: 0;
    }
`;

export default function CustomTable({
    setOrder,
    headCells,
    order,
    sign,
    rows,
    height,
    rowComponent,
    isLoading,
}) {
    const Row = rowComponent;
    const theme = useTheme();

    const createOrderHandler = (newOrder) => (event) => {
        setOrder(
            (newOrder == order ? (sign == "+" ? "-" : "+") : "+") + newOrder,
        );
    };

    return (
        <TableContainer sx={{ maxHeight: "70vh", height: height }}>
            <Table
                size="small"
                sx={{ minWidth: 650 }}
                aria-label="simple table"
            >
                <TableHead
                    sx={{
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                    }}
                >
                    <TableRow>
                        {headCells.map((headCell) => {
                            const CustomHeadCell = headCell.sticky
                                ? StickyCell
                                : TableCell;
                            return (
                                <CustomHeadCell
                                    key={headCell.id}
                                    variant="head"
                                    align={headCell.numeric ? "right" : "left"}
                                    padding={
                                        headCell.disablePadding
                                            ? "none"
                                            : "normal"
                                    }
                                    sx={{
                                        background:
                                            theme.palette.background.default,
                                    }}
                                >
                                    {headCell.orderable ? (
                                        <TableSortLabel
                                            active={order === headCell.id}
                                            direction={
                                                order === headCell.id
                                                    ? sign == "+"
                                                        ? "asc"
                                                        : "desc"
                                                    : "asc"
                                            }
                                            onClick={createOrderHandler(
                                                headCell.orderBy || headCell.id,
                                            )}
                                        >
                                            {headCell.label}
                                            {order === headCell.id ? (
                                                <Box
                                                    component="span"
                                                    sx={visuallyHidden}
                                                >
                                                    {sign == "-"
                                                        ? "sorted descending"
                                                        : "sorted ascending"}
                                                </Box>
                                            ) : null}
                                        </TableSortLabel>
                                    ) : (
                                        <Box>
                                            {headCell.labelComponent ||
                                                headCell.label}
                                        </Box>
                                    )}
                                </CustomHeadCell>
                            );
                        })}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {isLoading
                        ? Array.from({ length: 5 }).map((_, rowIdx) => (
                              <TableRow key={rowIdx}>
                                  {headCells.map((cell, colIdx) => (
                                      <TableCell
                                          key={colIdx}
                                          align={
                                              cell.numeric ? "right" : "left"
                                          }
                                      >
                                          <Skeleton
                                              variant="rectangular"
                                              height={24}
                                              sx={{ margin: "12px 0px" }}
                                          />
                                      </TableCell>
                                  ))}
                              </TableRow>
                          ))
                        : rows.map((row, index) => (
                              <Row key={index} {...row} />
                          ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
